/*
 * @Author: gaofengxiang gaofengxiang@gzsle.com
 * @Date: 2023-09-20 09:36:14
 * @LastEditors: gaofengxiang gaofengxiang@gzsle.com
 * @LastEditTime: 2023-09-20 11:28:17
 * @FilePath: \official-site\src\components\HomeBanner\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';

import Banner from '../Banner';
import banner1 from '../../static/banner/home-head/轮播首图1.jpg';
// import banner2 from '../../static/banner/home-head/轮播首图2.jpg';
import banner3 from '../../static/banner/home-head/轮播首图3.jpg';
// import banner5 from '../../static/banner/home-head/轮播首图5.jpg';
// import banner6 from '../../static/banner/home-head/轮播首图6.jpg';
import banner8 from '../../static/banner/home-head/轮播首图8.jpg';
import banner9 from '../../static/banner/home-head/轮播首图9.jpg';
// import banner10 from '../../static/banner/home-head/轮播首图10.jpg';
// import banner11 from '../../static/banner/home-head/轮播首图11.jpg';
import banner12 from '../../static/banner/home-head/轮播首图12.jpg';
import banner13 from '../../static/banner/home-head/轮播首图13.png';
import './index.sass';

// const urls = [banner1, banner2, banner3, banner4];
// 无糖茶、活力水平衡电解质水、多多、果汁茶、王爆爆、维c气泡果汁
const urls = [banner8, banner9, banner3, banner13, banner1, banner12];

export default function HomeBanner({ ...props }) {
  return <Banner urls={urls} />;
}
